/**
 * @file
 */

import { aspControlValidationInit, customValidationInit } from "@/common/validation/init.js";
import { CreateTHEADSectionGV } from "@/common/common.js";

const LOANSEQUENCE = 0;
const CONTRACTYPEDESC = 1;
const INCOMESHAREPERCENTAGE = 2;
const MONTHLYOBLIGATION = 3;

const currencyFormat = new Intl.NumberFormat('en-US', {
   style: 'currency',
   currency: 'USD',
   minimumFractionDigits: 2
})

export function InitializeIncomeChangePage() {
   // --------------------------------------------------------------------------
   // initialize the validation engine
   // --------------------------------------------------------------------------
   var onSubmit = false;
   customValidationInit(onSubmit);
   aspControlValidationInit();

   CreateTHEADSectionGV("gvCurrentObligations");
   CreateTHEADSectionGV("gvCalculateObligations");

   $('.responsiveTable').DataTable({
       "responsive": true,
       "scrollX": false,
       "paging": false,
       "searching": false,
       "ordering": false,
       "info": false
   });


   $("[id*='txtPercentAnnualPaymentObligation']").mask("9?99");

   $("#divTotalEstimatedMonthlyPaymentObligation").hide();
   $("#divIncomeBelowThreshold").hide();

  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-08
  window.validatePaymentEstimator = validatePaymentEstimator;
};

function validatePaymentEstimator() {
   var $agreementCheckboxes = $("input[type=checkbox]:checked");
   var $estimatedAnnualIncomeStr = $("[id$='txtEstimatedAnnualIncome']").val()

  if ($estimatedAnnualIncomeStr.length == 0 || !$.isNumeric($estimatedAnnualIncomeStr)) {
      $("[id$='txtEstimatedAnnualIncome']").validationEngine('showPrompt', 'You must enter an Estimated Annual Income Amount.  Enter 0.00 if you have no income.', 'error', 'topLeft', false);
      return false;
   }

   if ($agreementCheckboxes.length !== 3) {
      $("[id$='incomeStatementCheckboxes']").validationEngine('showPrompt', 'You must agree to all three statements.', 'error', 'topLeft', false);
      return false;
   }

   return true;
}
